import { Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { ModalComponent } from '@mhe/ngx-shared/modal';
import { intervalUntilTimestamp, waitUntilTimestamp } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/a11y";
import * as i2 from "@mhe/ngx-shared/translate";
import * as i3 from "@angular/common";
import * as i4 from "@mhe/ngx-shared/modal";
function TimeoutModalComponent_div_0_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "mheTranslate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "mheTranslate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.minutes, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.minutes === 1 ? i0.ɵɵpipeBind1(4, 2, i0.ɵɵpipeBind1(5, 4, "ngx-shared-minute")) : i0.ɵɵpipeBind1(6, 6, i0.ɵɵpipeBind1(7, 8, "ngx-shared-minutes")), " ");
} }
function TimeoutModalComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p")(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "mheTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "mheTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 5);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵpipe(12, "mheTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 6);
    i0.ɵɵtemplate(14, TimeoutModalComponent_div_0_div_2_div_14_Template, 8, 10, "div", 7);
    i0.ɵɵtext(15);
    i0.ɵɵelementStart(16, "span");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "async");
    i0.ɵɵpipe(19, "mheTranslate");
    i0.ɵɵpipe(20, "async");
    i0.ɵɵpipe(21, "mheTranslate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, i0.ɵɵpipeBind1(5, 8, "ngx-shared-due-to-inactivity")));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 10, i0.ɵɵpipeBind1(8, 12, "ngx-shared-you-will-be-logged-out-automatically")), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 14, i0.ɵɵpipeBind1(12, 16, "ngx-shared-your-session-will-expire-in")), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.showMinutes);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.seconds, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.seconds === 1 ? i0.ɵɵpipeBind1(18, 18, i0.ɵɵpipeBind1(19, 20, "ngx-shared-second")) : i0.ɵɵpipeBind1(20, 22, i0.ɵɵpipeBind1(21, 24, "ngx-shared-seconds")), " ");
} }
function TimeoutModalComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p")(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "mheTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "mheTranslate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, i0.ɵɵpipeBind1(5, 4, "ngx-shared-due-to-inactivity")));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, i0.ɵɵpipeBind1(8, 8, "ngx-shared-you-have-been-logged-out")), " ");
} }
function TimeoutModalComponent_div_0_p_4_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "mheTranslate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "mheTranslate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" \u00A0", ctx_r5.initialWarningMinutes, " ", ctx_r5.initialWarningMinutes === 1 ? i0.ɵɵpipeBind1(2, 2, i0.ɵɵpipeBind1(3, 4, "ngx-shared-minute")) : i0.ɵɵpipeBind1(4, 6, i0.ɵɵpipeBind1(5, 8, "ngx-shared-minutes")), " ");
} }
function TimeoutModalComponent_div_0_p_4_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "mheTranslate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "mheTranslate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" \u00A0", ctx_r6.initialWarningSeconds, " ", ctx_r6.initialWarningSeconds === 1 ? i0.ɵɵpipeBind1(2, 2, i0.ɵɵpipeBind1(3, 4, "ngx-shared-second")) : i0.ɵɵpipeBind1(4, 6, i0.ɵɵpipeBind1(5, 8, "ngx-shared-seconds")), ". ");
} }
function TimeoutModalComponent_div_0_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "mheTranslate");
    i0.ɵɵtemplate(4, TimeoutModalComponent_div_0_p_4_ng_container_4_Template, 6, 10, "ng-container", 3);
    i0.ɵɵtemplate(5, TimeoutModalComponent_div_0_p_4_ng_container_5_Template, 6, 10, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(3, 5, "ngx-shared-your-session-will-expire-in")), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.initialWarningMinutes > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.initialWarningSeconds > 0);
} }
function TimeoutModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "mhe-modal", 2);
    i0.ɵɵlistener("confirm", function TimeoutModalComponent_div_0_Template_mhe_modal_confirm_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onConfirm()); })("cancel", function TimeoutModalComponent_div_0_Template_mhe_modal_cancel_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onCancel()); });
    i0.ɵɵtemplate(2, TimeoutModalComponent_div_0_div_2_Template, 22, 26, "div", 3);
    i0.ɵɵtemplate(3, TimeoutModalComponent_div_0_div_3_Template, 9, 10, "div", 3);
    i0.ɵɵtemplate(4, TimeoutModalComponent_div_0_p_4_Template, 6, 7, "p", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isOpen", true)("titleText", ctx_r0.titleText)("focusOnConfirm", ctx_r0.focusOnConfirm)("disableClose", true)("disableEscape", true)("cancelButtonText", ctx_r0.cancelButtonText)("confirmButtonText", ctx_r0.confirmButtonText)("focusElementOnOverlayClick", ctx_r0.focusElementOnOverlayClick);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hasExpired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasExpired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hasExpired);
} }
export class TimeoutModalComponent {
    constructor(liveAnnouncer, translate) {
        this.liveAnnouncer = liveAnnouncer;
        this.translate = translate;
        this.titleText = 'Are you still there?';
        this.cancelButtonText = 'Log Out';
        this.confirmButtonText = 'Stay logged In';
        this.modalToggled = new EventEmitter();
        this.confirm = new EventEmitter();
        this.cancel = new EventEmitter();
        this.expired = new EventEmitter();
        this.focusOnConfirm = true;
        this.showMinutes = true;
        this.hasExpired = false;
        this.isOpen = false;
    }
    set showModalForSeconds(seconds) {
        this._showModalForSeconds = Math.round(seconds);
    }
    get showModalForSeconds() {
        return this._showModalForSeconds;
    }
    get showModalAtTimestamp() {
        if (!this.timeoutTimestamp) {
            return new Date();
        }
        return new Date(this.timeoutTimestamp.getTime() - this.showModalForSeconds * 1000);
    }
    ngOnChanges(changes) {
        if (this.hasExpired) {
            return;
        }
        const timeoutTimestampChanges = changes.timeoutTimestamp;
        if (!!timeoutTimestampChanges &&
            timeoutTimestampChanges.currentValue &&
            timeoutTimestampChanges.currentValue !== timeoutTimestampChanges.previousValue) {
            const timeoutTimestamp = timeoutTimestampChanges.currentValue;
            this.timeRemainingInSeconds = Math.round((timeoutTimestamp.getTime() - Date.now()) / 1000);
            this.initialWarningMinutes = Math.floor(this.showModalForSeconds / 60);
            this.initialWarningSeconds = Math.round(this.showModalForSeconds % 60);
            this.startSessionTimer();
        }
    }
    ngAfterContentChecked() {
        if (this.isOpen && this.modalComponent) {
            if (!this.hasExpired) {
                this.focusElementOnOverlayClick = this.modalComponent.confirmButton;
            }
            else {
                this.focusElementOnOverlayClick = this.modalComponent.cancelButton;
                this.modalComponent.cancelButton.nativeElement.focus();
            }
        }
    }
    startSessionTimer() {
        this.resetTimers();
        this.timeoutTimerSubscription = waitUntilTimestamp(this.showModalAtTimestamp).subscribe(this.onSessionTimerComplete.bind(this));
    }
    startModalTimer() {
        this.toggleModal(true);
        this.modalTimerSubscription = intervalUntilTimestamp(this.timeoutTimestamp, 1000).subscribe({
            next: this.onModalTimerInterval.bind(this),
            error: (err) => err,
            complete: this.onModalTimerComplete.bind(this),
        });
    }
    resetTimers() {
        if (!!this.modalTimerSubscription) {
            this.modalTimerSubscription.unsubscribe();
        }
        if (!!this.timeoutTimerSubscription) {
            this.timeoutTimerSubscription.unsubscribe();
        }
        this.toggleModal(false);
    }
    onCancel() {
        this.resetTimers();
        this.cancel.emit();
    }
    onConfirm() {
        this.confirm.emit();
    }
    announceTimeRemaining(secondsRemaining) {
        if (secondsRemaining === 15) {
            this.translate.translate('ngx-shared-seconds').subscribe((seconds) => {
                this.translate.translate('ngx-shared-remaining').subscribe((remaining) => {
                    void this.liveAnnouncer.announce(`${secondsRemaining} ${seconds} ${remaining}`);
                });
            });
        }
        else if (secondsRemaining === 60) {
            this.translate.translate('ngx-shared-minute').subscribe((minute) => {
                this.translate.translate('ngx-shared-seconds').subscribe((seconds) => {
                    this.translate.translate('ngx-shared-remaining').subscribe((remaining) => {
                        void this.liveAnnouncer.announce(`1 ${minute} 0 ${seconds} ${remaining}`);
                    });
                });
            });
        }
    }
    onSessionTimerComplete() {
        this.timeoutTimerSubscription.unsubscribe();
        this.startModalTimer();
    }
    onModalTimerInterval(remainingMilliseconds) {
        this.timeRemainingInSeconds = Math.round(remainingMilliseconds / 1000);
        if (this.timeRemainingInSeconds > 0) {
            this.minutes = Math.floor(this.timeRemainingInSeconds / 60);
            this.seconds = Math.round(this.timeRemainingInSeconds % 60);
            this.showMinutes = this.timeRemainingInSeconds > 59;
            this.announceTimeRemaining(this.timeRemainingInSeconds);
        }
    }
    onModalTimerComplete() {
        this.translate.translate('ngx-shared-due-to-inactivity').subscribe((thing1) => {
            this.translate.translate('ngx-shared-you-have-been-logged-out').subscribe((thing2) => {
                void this.liveAnnouncer.announce(`${thing1} ${thing2}`);
            });
        });
        this.confirmButtonText = '';
        this.focusOnConfirm = false;
        this.timeRemainingInSeconds = this.minutes = this.seconds = 0;
        this.hasExpired = true;
        this.modalTimerSubscription.unsubscribe();
        this.expired.emit();
    }
    toggleModal(isOpen) {
        if (isOpen !== this.isOpen) {
            this.isOpen = isOpen;
            this.modalToggled.emit(isOpen);
        }
    }
}
TimeoutModalComponent.ɵfac = function TimeoutModalComponent_Factory(t) { return new (t || TimeoutModalComponent)(i0.ɵɵdirectiveInject(i1.LiveAnnouncer), i0.ɵɵdirectiveInject(i2.TranslateService)); };
TimeoutModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TimeoutModalComponent, selectors: [["mhe-timeout-modal"]], viewQuery: function TimeoutModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalComponent = _t.first);
    } }, inputs: { timeoutTimestamp: "timeoutTimestamp", titleText: "titleText", cancelButtonText: "cancelButtonText", confirmButtonText: "confirmButtonText", showModalForSeconds: "showModalForSeconds" }, outputs: { modalToggled: "modalToggled", confirm: "confirm", cancel: "cancel", expired: "expired" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "timeout-modal", 4, "ngIf"], [1, "timeout-modal"], [3, "isOpen", "titleText", "focusOnConfirm", "disableClose", "disableEscape", "cancelButtonText", "confirmButtonText", "focusElementOnOverlayClick", "confirm", "cancel"], [4, "ngIf"], ["class", "visually-hidden", 4, "ngIf"], ["aria-hidden", "true", 1, "timeout-modal__session-expiration-msg"], ["aria-hidden", "true", 1, "timeout-modal__time-remaining"], ["class", "timeout-modal__minutes-display", 4, "ngIf"], [1, "timeout-modal__minutes-display"], [1, "visually-hidden"]], template: function TimeoutModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TimeoutModalComponent_div_0_Template, 5, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, dependencies: [i3.NgIf, i4.ModalComponent, i3.AsyncPipe, i2.TranslatePipe], styles: [".timeout-modal[_ngcontent-%COMP%]   .dpg-icon-clock[_ngcontent-%COMP%]{width:90px;height:90px}.timeout-modal[_ngcontent-%COMP%]   .timeout-modal__session-expiration-msg[_ngcontent-%COMP%]{margin:0}.timeout-modal[_ngcontent-%COMP%]   .timeout-modal__time-remaining[_ngcontent-%COMP%]{font-size:24px;font-weight:500}.timeout-modal[_ngcontent-%COMP%]   .timeout-modal__time-remaining[_ngcontent-%COMP%]   .timeout-modal__minutes-display[_ngcontent-%COMP%]{display:inline-block}.timeout-modal[_ngcontent-%COMP%]   .timeout-modal__time-remaining[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;font-size:16px;font-weight:400}.visually-hidden[_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimeoutModalComponent, [{
        type: Component,
        args: [{ selector: 'mhe-timeout-modal', template: "<div *ngIf=\"isOpen\" class=\"timeout-modal\">\n  <mhe-modal\n    [isOpen]=\"true\"\n    [titleText]=\"titleText\"\n    [focusOnConfirm]=\"focusOnConfirm\"\n    [disableClose]=\"true\"\n    [disableEscape]=\"true\"\n    [cancelButtonText]=\"cancelButtonText\"\n    [confirmButtonText]=\"confirmButtonText\"\n    [focusElementOnOverlayClick]=\"focusElementOnOverlayClick\"\n    (confirm)=\"onConfirm()\"\n    (cancel)=\"onCancel()\"\n  >\n    <div *ngIf=\"!hasExpired\">\n      <p>\n        <b>{{ 'ngx-shared-due-to-inactivity' | mheTranslate | async }}</b>\n        {{ 'ngx-shared-you-will-be-logged-out-automatically' | mheTranslate | async }}\n      </p>\n      <p class=\"timeout-modal__session-expiration-msg\" aria-hidden=\"true\">\n        {{ 'ngx-shared-your-session-will-expire-in' | mheTranslate | async }}\n      </p>\n      <!-- TODO: Add Pluralization -->\n      <div class=\"timeout-modal__time-remaining\" aria-hidden=\"true\">\n        <div class=\"timeout-modal__minutes-display\" *ngIf=\"showMinutes\">\n          {{ minutes }}\n          <span>\n            {{\n              minutes === 1\n                ? ('ngx-shared-minute' | mheTranslate | async)\n                : ('ngx-shared-minutes' | mheTranslate | async)\n            }}\n          </span>\n        </div>\n        {{ seconds }}\n        <span>\n          {{\n            seconds === 1\n              ? ('ngx-shared-second' | mheTranslate | async)\n              : ('ngx-shared-seconds' | mheTranslate | async)\n          }}\n        </span>\n      </div>\n    </div>\n    <div *ngIf=\"hasExpired\">\n      <p>\n        <b>{{ 'ngx-shared-due-to-inactivity' | mheTranslate | async }}</b>\n        {{ 'ngx-shared-you-have-been-logged-out' | mheTranslate | async }}\n      </p>\n    </div>\n    <!-- TODO: Add Pluralization -->\n    <p *ngIf=\"!hasExpired\" class=\"visually-hidden\">\n      {{ 'ngx-shared-your-session-will-expire-in' | mheTranslate | async }}\n      <ng-container *ngIf=\"initialWarningMinutes > 0\">\n        &nbsp;{{ initialWarningMinutes }}\n        {{\n          initialWarningMinutes === 1\n            ? ('ngx-shared-minute' | mheTranslate | async)\n            : ('ngx-shared-minutes' | mheTranslate | async)\n        }}\n      </ng-container>\n      <ng-container *ngIf=\"initialWarningSeconds > 0\">\n        &nbsp;{{ initialWarningSeconds }}\n        {{\n          initialWarningSeconds === 1\n            ? ('ngx-shared-second' | mheTranslate | async)\n            : ('ngx-shared-seconds' | mheTranslate | async)\n        }}.\n      </ng-container>\n    </p>\n  </mhe-modal>\n</div>\n", styles: [".timeout-modal .dpg-icon-clock{width:90px;height:90px}.timeout-modal .timeout-modal__session-expiration-msg{margin:0}.timeout-modal .timeout-modal__time-remaining{font-size:24px;font-weight:500}.timeout-modal .timeout-modal__time-remaining .timeout-modal__minutes-display{display:inline-block}.timeout-modal .timeout-modal__time-remaining span{display:inline-block;font-size:16px;font-weight:400}.visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}/*# sourceMappingURL=timeout-modal.component.css.map */\n"] }]
    }], function () { return [{ type: i1.LiveAnnouncer }, { type: i2.TranslateService }]; }, { timeoutTimestamp: [{
            type: Input
        }], titleText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], confirmButtonText: [{
            type: Input
        }], showModalForSeconds: [{
            type: Input
        }], modalToggled: [{
            type: Output
        }], confirm: [{
            type: Output
        }], cancel: [{
            type: Output
        }], expired: [{
            type: Output
        }], modalComponent: [{
            type: ViewChild,
            args: [ModalComponent]
        }] }); })();
